<template>
	<div class="AppUpdateStore">
		<div class="AppUpdateStore__card">
			<div>
				<div class="AppUpdateStore__heading-card">
					<span>Update Store</span>
				</div>
				<div style="text-align: right;">
					<button
						style="background-color: #f49c57; color: white; padding: 10px 20px; border-radius: 3px;"
						@click="redirectToBack"
					>
						&#x2B05; Back
					</button>
				</div>
				<div v-if="type == 'edit'" class="all-rows" @submit.prevent>
					<el-row :gutter="40">
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<div>
								<label>
									Store Name<span style="color: red;">
										*
									</span>
								</label>
								<input
									v-model="store_name"
									v-validate="'required'"
									type="text"
									class="custom-input"
									name="Store name"
								/>
								<span
									v-show="errors.has('Store name')"
									class="text-red-dark text-xs"
								>
									{{ errors.first("Store name") }}
								</span>
							</div>
						</el-col>
						<el-col
							:xs="24"
							:sm="24"
							:md="12"
							:lg="12"
							:xl="12"
							class="grid-margin"
						>
							<div>
								<label>
									Store Status<span style="color: red;">
										*
									</span>
								</label>
								<el-select
									v-model="store_status"
									v-validate="'required'"
									name="Store status"
									placeholder="Store status"
									style="width: 100%;"
								>
									<el-option value="true" label="Active">
										Active
									</el-option>
									<el-option value="false" label="Inactive">
										Inactive
									</el-option>
								</el-select>
								<span
									v-show="errors.has('Store status')"
									class="text-red-dark text-xs"
								>
									{{ errors.first("Store status") }}
								</span>
							</div>
						</el-col>
					</el-row>
					<el-row class="set-top-margin" :gutter="40">
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<label>
								country<span style="color: red;">
									*
								</span>
							</label>
							<el-select
								v-model="country"
								v-validate="'required'"
								placeholder="Country"
								allow-create
								default-first-option
								filterable
								auto-complete="off"
								style="width: 100%"
								name="Country"
								@change="getRegionFromCountry('country')"
							>
								<el-option
									v-for="(item, index) in response_location_data"
									:key="index"
									:value="item.id ? item.id : country"
									:label="item.name"
								>
									{{ item.name }}
								</el-option>
							</el-select>
							<span
								v-show="errors.has('Country')"
								class="text-red-dark text-xs"
							>
								{{ errors.first("Country") }}
							</span>
						</el-col>
						<el-col
							:xs="24"
							:sm="24"
							:md="12"
							:lg="12"
							:xl="12"
							class="grid-margin"
						>
							<label class="input-label">
								City<span style="color: red;">
									*
								</span>
							</label>
							<el-select
								v-model="city"
								v-validate="'required'"
								placeholder="City"
								default-first-option
								filterable
								style="width: 100%;"
								name="city"
							>
								<el-option
									v-for="(city, index) in all_city"
									:key="index"
									:value="city.id"
									:label="city.name"
								>
									{{ city.name }}
								</el-option>
							</el-select>
							<span v-show="errors.has('city')" class="text-red-dark text-xs">
								{{ errors.first("city") }}
							</span>
						</el-col>
					</el-row>
					<el-row class="set-top-margin" :gutter="40">
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<label>Region</label>
							<el-select
								v-model="region"
								placeholder="Region"
								allow-create
								default-first-option
								filterable
								style="width: 100%;"
								@change="getRegionFromCountry()"
							>
								<el-option
									v-for="(region, index) in all_region"
									:key="index"
									:value="region.id"
									:label="region.name"
								>
									{{ region.name }}
								</el-option>
							</el-select>
						</el-col>
						<el-col
							:xs="24"
							:sm="24"
							:md="12"
							:lg="12"
							:xl="12"
							class="grid-margin"
						>
							<label>Sub Region</label>
							<div v-if="region">
								<el-select
									v-model="sub_region"
									placeholder="Subregion"
									allow-create
									default-first-option
									filterable
									style="width: 100%;"
									@change="getRegionFromCountry()"
								>
									<el-option
										v-for="(subregion, index) in all_sub_region"
										:key="index"
										:value="subregion.id"
										:label="subregion.name"
									>
										{{ subregion.name }}
									</el-option>
								</el-select>
							</div>
							<div v-else>
								<el-select
									v-model="sub_region"
									placeholder="Subregion"
									allow-create
									default-first-option
									filterable
									style="width: 100%;"
									disabled
									@change="getRegionFromCountry()"
								>
									<el-option
										v-for="(subregion, index) in all_sub_region"
										:key="index"
										:value="subregion.id"
										:label="subregion.name"
									>
										{{ subregion.name }}
									</el-option>
								</el-select>
							</div>
						</el-col>
					</el-row>
					<el-row class="set-top-margin" :gutter="40">
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<label>
								Account Type<span style="color: red;">
									*
								</span>
							</label>
							<el-select
								v-model="account_type"
								v-validate="'required'"
								placeholder="Account type"
								style="width: 100%;"
								name="Account type"
								@change="account_type != 'store' ? (store_type = '') : null"
							>
								<el-option value="store" label="store">
									Store
								</el-option>
								<el-option value="warehouse" label="warehouse">
									Warehouse
								</el-option>
								<el-option value="central_kitchen" label="Central Kitchen">
									Central Kitchen
								</el-option>
								<el-option value="head_office" label="Head office">
									<!-- store, , central_kitchen, head_office, ,  -->
									Head Office
								</el-option>
								<el-option value="regional_office" label="Regional office">
									Regional Office
								</el-option>
								<el-option value="vendor" label="vendor">
									Vendor
								</el-option>
							</el-select>
							<span
								v-show="errors.has('Account type')"
								class="text-red-dark text-xs"
							>
								{{ errors.first("Account type") }}
							</span>
						</el-col>
						<el-col
							:xs="24"
							:sm="24"
							:md="12"
							:lg="12"
							:xl="12"
							class="grid-margin"
						>
							<label>Store Type</label>
							<el-input
								v-model="store_type"
								type="text"
								name="storeName"
								placeholder="Store type"
								:disabled="account_type != 'store'"
							/>
						</el-col>
					</el-row>
					<el-row class="set-top-margin" :gutter="40">
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<label>
								Email<span style="color: red;">
									*
								</span>
							</label>
							<input
								v-model="email"
								v-validate="'required|email'"
								type="text"
								class="custom-input"
								name="Email"
							/>
							<span class="text-red-dark text-xs">
								{{ errors.first("Email") }}
							</span>
						</el-col>
						<el-col
							:xs="24"
							:sm="24"
							:md="12"
							:lg="12"
							:xl="12"
							class="grid-margin"
						>
							<label>Contact Number</label>
							<input
								v-model="phone"
								v-validate="'required'"
								type="text"
								class="custom-input"
								maxlength="10"
								name="Contact"
							/>
							<span
								v-show="errors.has('Contact')"
								class="text-red-dark text-xs"
							>
								{{ errors.first("Contact") }}
							</span>
						</el-col>
					</el-row>
					<el-row class="set-top-margin" :gutter="40">
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<label>
								Geo Location<span style="color: red;">
									*
								</span>
							</label>
							<input
								v-model="latitude"
								v-validate="'required'"
								type="text"
								class="custom-input"
								placeholder="Latitude"
								name="Latitude"
							/>
							<span
								v-show="errors.has('Latitude')"
								class="text-red-dark text-xs"
							>
								{{ errors.first("Latitude") }}
							</span>
						</el-col>
						<el-col
							:xs="24"
							:sm="24"
							:md="12"
							:lg="12"
							:xl="12"
							class="grid-margin"
						>
							<label>
								Geo Location<span style="color: red;">
									*
								</span>
							</label>
							<input
								v-model="longitude"
								v-validate="'required'"
								type="text"
								class="custom-input"
								placeholder="Longitude"
								name="Longitude"
							/>
							<span
								v-show="errors.has('Longitude')"
								class="text-red-dark text-xs"
							>
								{{ errors.first("Longitude") }}
							</span>
						</el-col>
					</el-row>
					<el-row class="set-top-margin" :gutter="40">
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<label>
								Address<span style="color: red;">
									*
								</span>
							</label>
							<textarea
								v-model="address"
								v-validate="'required'"
								name="Address"
								class="custom-input"
								style="resize: none;"
								placeholder="Enter Address"
							/>
							<span
								v-show="errors.has('Address')"
								class="text-red-dark text-xs"
							>
								{{ errors.first("Address") }}
							</span>
						</el-col>
						<el-col
							:xs="24"
							:sm="24"
							:md="12"
							:lg="12"
							:xl="12"
							class="grid-margin"
						>
							<!-- <label>Address (Optional)</label>
                <input
                  type="text"
                  class="custom-input"
                  v-model="address1"
                > -->
						</el-col>
					</el-row>
				</div>
				<div v-else class="all-rows">
					<el-row :gutter="40">
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<p class="view_heading">
								Store Name:
							</p>
							<p class="view_content">
								{{ store_name }}
							</p>
						</el-col>
						<el-col
							:xs="24"
							:sm="24"
							:md="12"
							:lg="12"
							:xl="12"
							class="grid-margin"
						>
							<p class="view_heading">
								Store Status:
							</p>
							<p v-if="store_status" class="view_content">
								Active
							</p>
							<p v-else class="view_content">
								In-Active
							</p>
						</el-col>
					</el-row>
					<el-row class="set-top-margin" :gutter="40">
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<p class="view_heading">
								Country:
							</p>
							<p
								v-for="(item, index) in response_location_data"
								:key="index"
								class="view_content"
							>
								<span v-if="item.id == country">
									{{ item.name }}
								</span>
							</p>
						</el-col>
						<el-col
							:xs="24"
							:sm="24"
							:md="12"
							:lg="12"
							:xl="12"
							class="grid-margin"
						>
							<p class="view_heading">
								City:
							</p>
							<p
								v-for="(city_item, index) in all_city"
								:key="index"
								class="view_content"
							>
								<span v-if="city_item.id == city">
									{{ city_item.name }}
								</span>
							</p>
						</el-col>
					</el-row>
					<el-row class="set-top-margin" :gutter="40">
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<p class="view_heading">
								Region:
							</p>
							<p class="view_content">
								{{ region }}
							</p>
						</el-col>
						<el-col
							:xs="24"
							:sm="24"
							:md="12"
							:lg="12"
							:xl="12"
							class="grid-margin"
						>
							<p class="view_heading">
								Sub Region:
							</p>
							<p class="view_content">
								{{ sub_region }}
							</p>
						</el-col>
					</el-row>
					<el-row class="set-top-margin" :gutter="40">
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<p class="view_heading">
								Account Type:
							</p>
							<p class="view_content">
								{{ account_type }}
							</p>
						</el-col>
						<el-col
							:xs="24"
							:sm="24"
							:md="12"
							:lg="12"
							:xl="12"
							class="grid-margin"
						>
							<p class="view_heading">
								Store type:
							</p>
							<p class="view_content">
								{{ store_type }}
							</p>
						</el-col>
					</el-row>
					<el-row class="set-top-margin" :gutter="40">
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<p class="view_heading">
								Email:
							</p>
							<p class="view_content">
								{{ email }}
							</p>
						</el-col>
						<el-col
							:xs="24"
							:sm="24"
							:md="12"
							:lg="12"
							:xl="12"
							class="grid-margin"
						>
							<p class="view_heading">
								Contact Number:
							</p>
							<p class="view_content">
								{{ email }}
							</p>
						</el-col>
					</el-row>
					<el-row class="set-top-margin" :gutter="40">
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<p class="view_heading">
								Geo Location (Latitude):
							</p>
							<p class="view_content">
								{{ latitude }}
							</p>
						</el-col>
						<el-col
							:xs="24"
							:sm="24"
							:md="12"
							:lg="12"
							:xl="12"
							class="grid-margin"
						>
							<p class="view_heading">
								Geo Location (Longitude):
							</p>
							<p class="view_content">
								{{ longitude }}
							</p>
						</el-col>
					</el-row>
					<el-row class="set-top-margin" :gutter="40">
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<p class="view_heading">
								Address:
							</p>
							<p class="view_content">
								{{ address }}
							</p>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<div class="AppUpdateStore__card" style="margin-top: 50px !important;">
			<div class="AppUpdateStore__heading-card">
				<span>User</span>
			</div>
			<div v-if="type == 'edit'" class="AppUpdateStore__table">
				<table>
					<tr id="table__main_headings">
						<th colspan="4">
							Employee Details
						</th>
						<th colspan="15">
							User Permissions
						</th>
					</tr>

					<tr id="table__sub_headings">
						<th v-if="show_delete_options == true">
							Remove Detail
						</th>
						<th>First Name</th>
						<th>Last Name</th>
						<th>
							Email Id<span style="color: red;">
								*
							</span>
						</th>
						<th>Designation</th>
						<th colspan="2">
							Forecast
						</th>
						<th colspan="4">
							Replenishment
						</th>
						<th colspan="2">
							Expiry
						</th>
						<th colspan="6">
							Inventory Management
						</th>
					</tr>

					<tr>
						<td />
						<td />
						<td />
						<td />
						<th>View</th>
						<th>Edit</th>
						<th>View</th>
						<th>Edit</th>
						<th>Order Value Limit</th>
						<th>Approve</th>
						<th>View</th>
						<th>Edit</th>
						<th>View</th>
						<th>Edit</th>
						<th>Movement</th>
						<th>Value</th>
						<th>Sell</th>
						<th>Approve</th>
					</tr>

					<tr v-for="(item, index) in add_user_row" :key="index">
						<td v-if="show_delete_options == true">
							<input
								v-if="item.disabled == true"
								v-model="item.delete_user"
								type="checkbox"
							/>
						</td>
						<td>
							<input
								v-model="item.first_name"
								v-validate="'max:30'"
								type="text"
								class="table-input"
								:name="'First name' + index"
							/>
							<div
								v-show="errors.has('First name' + index)"
								class="text-red-dark text-xs"
							>
								{{ errors.first("First name" + index) }}
							</div>
						</td>
						<td>
							<input
								v-model="item.last_name"
								v-validate="'max:30'"
								type="text"
								class="table-input"
								:name="'Last name' + index"
							/>
							<div
								v-show="errors.has('Last name' + index)"
								class="text-red-dark text-xs"
							>
								{{ errors.first("Last name" + index) }}
							</div>
						</td>
						<td>
							<input
								v-model="item.email"
								v-validate="'email'"
								type="text"
								class="table-input"
								style="width: 300px;"
								:disabled="item.disabled == true"
								:name="'Email' + index"
							/>
							<div
								v-show="errors.has('Email' + index)"
								class="text-red-dark text-xs"
							>
								{{ errors.first("Email" + index) }}
							</div>
						</td>
						<td>
							<input
								v-model="item.designation"
								type="text"
								class="table-input"
							/>
						</td>
						<td>
							<el-switch v-model="item.value1" />
						</td>
						<td>
							<el-switch v-model="item.value2" />
						</td>
						<td>
							<el-switch v-model="item.value3" />
						</td>
						<td>
							<el-switch v-model="item.value4" />
						</td>
						<td>
							<el-switch v-model="item.value5" />
						</td>
						<td>
							<el-switch v-model="item.value6" />
						</td>
						<td>
							<el-switch v-model="item.value7" />
						</td>
						<td>
							<el-switch v-model="item.value8" />
						</td>
						<td>
							<el-switch v-model="item.value9" />
						</td>
						<td>
							<el-switch v-model="item.value10" />
						</td>
						<td>
							<el-switch v-model="item.value11" />
						</td>
						<td>
							<el-switch v-model="item.value12" />
						</td>
						<td>
							<el-switch v-model="item.value13" />
						</td>
						<td>
							<el-switch v-model="item.value14" />
						</td>
						<!-- <td>
                <el-switch
                  v-model="value14"
                />
              </td> -->
					</tr>
				</table>
			</div>
			<div v-else>
				<div v-if="add_user_row.length > 0" class="AppUpdateStore__table">
					<table>
						<tr id="table__main_headings">
							<th colspan="4">
								Employee Details
							</th>
							<th colspan="15">
								User Permissions
							</th>
						</tr>

						<tr id="table__sub_headings">
							<th>First Name</th>
							<th>Last Name</th>
							<th>
								Email Id<span style="color: red;">
									*
								</span>
							</th>
							<th>Designation</th>
							<th colspan="2">
								Forecast
							</th>
							<th colspan="4">
								Replenishment
							</th>
							<th colspan="2">
								Expiry
							</th>
							<th colspan="6">
								Inventory Management
							</th>
						</tr>

						<tr>
							<td />
							<td />
							<td />
							<th>View</th>
							<th>Edit</th>
							<th>View</th>
							<th>Edit</th>
							<th>Order Value Limit</th>
							<th>Approve</th>
							<th>View</th>
							<th>Edit</th>
							<th>View</th>
							<th>Edit</th>
							<th>Movement</th>
							<th>Value</th>
							<th>Sell</th>
							<th>Approve</th>
						</tr>

						<tr v-for="(item, index) in add_user_row" :key="index">
							<td>{{ item.first_name }}</td>
							<td>{{ item.last_name }}</td>
							<td>{{ item.email }}</td>
							<td>{{ item.designation }}</td>
							<td>{{ item.value1 }}</td>
							<td>{{ item.value2 }}</td>
							<td>{{ item.value3 }}</td>
							<td>{{ item.value4 }}</td>
							<td>{{ item.value5 }}</td>
							<td>{{ item.value6 }}</td>
							<td>{{ item.value7 }}</td>
							<td>{{ item.value8 }}</td>
							<td>{{ item.value9 }}</td>
							<td>{{ item.value10 }}</td>
							<td>{{ item.value11 }}</td>
							<td>{{ item.value12 }}</td>
							<td>{{ item.value13 }}</td>
							<td>{{ item.value14 }}</td>
						</tr>
					</table>
				</div>
				<div v-else>
					<h3
						style="font-size: 14px; color: #f49c57; font-wight: bold; text-align: center;"
					>
						User are not avaliable!
					</h3>
				</div>
			</div>
			<button v-if="type == 'edit'" class="back-btn" @click="addRow">
				Add User
			</button>
			<button
				v-if="type == 'edit' && show_delete_btn && show_delete_options == false"
				class="back-btn"
				@click="shownDeleteOptions()"
			>
				Delete
			</button>
			<button
				v-if="show_delete_options == true"
				class="back-btn"
				@click="deleteUser"
			>
				Confirm Delete
			</button>

			<div v-if="type == 'edit'" class="position-right-btn">
				<button class="back-btn" @click="editStoreByCountry()">
					Update Store
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { serverAddr } from "../../../networkConfig.js";
import { appUpdateStoreNetworkCallback } from "../../../../mixins/appUpdateStoreNC.js";
export default {
	name: "AppUpdateStore",
	mixins: [appUpdateStoreNetworkCallback],
	props: ["type"],
	data() {
		return {
			value1: false,
			value2: false,
			value3: false,
			value4: false,
			value5: false,
			value6: false,
			value7: false,
			value8: false,
			value9: false,
			value10: false,
			value11: false,
			value12: false,
			value13: false,
			value14: false,
			value: "",
			id: "",
			store_name: "",
			country: "",
			all_region: [],
			region: null,
			all_sub_region: "",
			sub_region: null,
			account_type: "",
			store_type: "",
			email: "",
			phone: "",
			website: "",
			all_states: [],
			selected_state: " ",
			response_location_data: [],
			latitude: "",
			longitude: "",
			check_box_key: false,
			confirm_del_btn: false,
			add_user_row: [
				{
					first_name: "",
					last_name: "",
					email: "",
					designation: ""
				}
			],
			loginUserEmail: "",
			store_state_id: "",
			store_country_id: "",
			store_region_id: null,
			store_subregion_id: null,
			store_status: "",
			address: "",
			all_city: [],
			city: "",
			delete_user_list: [],
			show_delete_btn: false,
			show_delete_options: false
		};
	},
	computed: {
		user_info() {
			return this.$store.state.loginUserDetails;
		},
		outlet_details() {
			return this.$store.state.outletData;
		}
	},
	created() {
		this.getCountry();
		serverAddr
			.get("/outlet/city/", {})
			.then(this.getAllCity)
			.catch(error => {
				// this.$notify.error({});
			});
		this.updateAllFileds();
		this.loginUserEmail = this.user_info.email;
	},
	methods: {
		updateAllFileds() {
			if (this.outlet_details != "") {
				this.store_name = this.outlet_details.name;
				this.website = this.outlet_details.website;
				this.phone = this.outlet_details.phone;
				this.email = this.outlet_details.email;
				this.account_type = this.outlet_details.type;
				this.store_type = this.outlet_details.store_type;
				this.selected_state = this.outlet_details.states;
				this.region = this.outlet_details.region;
				this.sub_region = this.outlet_details.subregion;
				this.latitude = this.outlet_details.latitude;
				this.longitude = this.outlet_details.longitude;
				this.address = this.outlet_details.address;
				this.store_status = String(this.outlet_details.active);
				this.city = this.outlet_details.city;
				this.add_user_row = this.outlet_details.users;
				if (this.type == "edit") {
					// **************user list**************
					for (var j in this.add_user_row) {
						if (this.add_user_row[j].email != "") {
							this.show_delete_btn = true;
							this.add_user_row[j].disabled = true;
							this.add_user_row[j].delete_user = false;
						}
					}
					//***********set default 3 user row in table */
					if (this.add_user_row.length < 3) {
						var temp = 3 - Number(this.add_user_row.length);
						for (var i = 0; i < temp; i++) {
							this.add_user_row.push({
								disabled: false,
								first_name: "",
								last_name: "",
								email: "",
								designation: "",
								delete_user: false
							});
						}
					}
				}
			}
		},
		addRow() {
			this.add_user_row.push({
				disabled: false,
				first_name: "",
				last_name: "",
				email: "",
				designation: "",
				delete_user: false
			});
		},
		redirectToBack() {
			this.$router.push("/app-store-details").catch(()=>{});
		},

		editStoreByCountry(btn_type) {
			this.$validator.validateAll().then(result => {
				if (result) {
					var letters = /^[0-9a-zA-Z]+$/;
					if (!this.country.match(letters) && this.country.length == 36) {
						this.updateStoreInfo();
					} else {
						serverAddr
							.post("/outlet/country/", {
								name: this.country
							})
							.then(res => {
								this.store_country_id = JSON.parse(res.data).id;
								if (this.region != null) {
									this.editStoreByRegion(this.store_country_id);
								}
							})
							.catch(error => {
								this.$notify.error({
									title: "fail",
									message: JSON.parse(error.response.data).name[0]
								});
							});
					}
				}
			});
		},

		editStoreByRegion(store_state_id) {
			serverAddr
				.post("/outlet/region/", {
					name: this.region,
					country: store_state_id
				})

				.then(this.postRegionNC)
				.catch(error => {
					this.$notify.error({
						title: "fail",
						message: JSON.parse(error.response.data).name[0]
					});
				});
		},
		postSubRegion(store_region_id) {
			serverAddr
				.post("/outlet/subregion/", {
					name: this.sub_region,
					region: store_region_id
				})
				.then(response => {
					this.store_subregion_id = JSON.parse(response.data).id;
					this.updateStoreManualInfo(this.store_subregion_id);
				})
				.catch(error => {
					console.log("error", error);
					this.$notify.error({
						title: "fail",
						message: JSON.parse(error.response.data).name[0]
					});
				});
		},
		updateStoreInfo() {
			serverAddr
				.patch(`/outlet/${this.outlet_details.id}/`, {
					id: this.outlet_details.id,
					name: this.store_name,
					website: this.website,
					phone: this.phone,
					email: this.email,
					type: this.account_type,
					store_type: this.account_type == "store" ? this.store_type : "",
					country: this.country,
					states: this.selected_state,
					region: this.region,
					subregion: this.sub_region,
					latitude: this.latitude,
					longitude: this.longitude,
					address: this.address,
					active: this.store_status,
					city: this.city
				})
				.then(response => {
					this.updateUsers(JSON.parse(response.data).id);
				})
				.catch(error => {
					console.log("error", JSON.parse(error));
				});
		},
		updateStoreManualInfo() {
			console.log("updateStoreManualInfo");
			serverAddr
				.patch(`/outlet/${this.outlet_details.id}/`, {
					id: this.outlet_details.id,
					name: this.store_name,
					website: this.website,
					phone: this.phone,
					email: this.email,
					type: this.account_type,
					store_type: this.store_type,
					country: this.store_country_id,
					// states: this.store_state_id,
					region: this.store_region_id,
					subregion: this.store_subregion_id,
					latitude: this.latitude,
					longitude: this.longitude,
					address: this.address
				})
				.then(response => {
					this.updateUsers(JSON.parse(response.data).id);
				})
				.catch(error => {
					console.log("error", JSON.parse(error));
				});
		},
		updateUsers(store_outlet) {
			var list = [];
			for (var i = 0; i < this.add_user_row.length; i++) {
				if (
					this.add_user_row[i].email != "" ||
					this.add_user_row[i].first_name != "" ||
					this.add_user_row[i].last_name != ""
				) {
					var temp = {
						email: this.add_user_row[i].email,
						first_name: this.add_user_row[i].first_name,
						last_name: this.add_user_row[i].last_name,
						designation: this.add_user_row[i].designation,
						outlet: store_outlet
					};
					list.push(temp);
				} else {
					this.add_user_row.splice(i, 1);
				}
			}
			serverAddr
				.post("/users/create_update/", list)
				// .then(this.postUpdateUserDetails)
				.then(response => {
					if (response) {
						this.$notify.success({
							title: "Success",
							message: "Store update successfully"
						});
						this.$router.push("/app-store-details").catch(()=>{});
					}
				})
				.catch(error => {
					this.$notify.error({
						title: "Fail",
						message: JSON.parse(error.response.data).name[0]
					});
				});
		},
		getCountry() {
			serverAddr
				.get("/outlet/location/", {})
				.then(response => {
					this.response_location_data = JSON.parse(response.data).results;
					for (var i = 0; i < this.response_location_data.length; i++) {
						if (
							this.response_location_data[i].name == this.outlet_details.country
						) {
							this.country = this.response_location_data[i].id;
							this.all_region = this.response_location_data[i].regions;
						}
					}
				})
				.catch(error => {
					// this.$notify.error({});
				});
		},
		getRegionFromCountry(country) {
			if (country) {
				this.region = null;
				this.sub_region = null;
			}
			for (var i = 0; i < this.response_location_data.length; i++) {
				if (this.response_location_data[i].id == this.country) {
					this.all_region = this.response_location_data[i].regions;
					for (
						var j = 0;
						j < this.response_location_data[i].regions.length;
						j++
					) {
						if (
							this.response_location_data[i].regions[j].country == this.country
						) {
							this.all_sub_region = this.response_location_data[i].regions[
								j
							].subregions;
						}
					}
				}
			}
		},
		deleteUser() {
			for (var i in this.add_user_row) {
				if (this.add_user_row[i].delete_user) {
					this.delete_user_list.push(this.add_user_row[i].email);
				}
			}
			serverAddr
				.delete("/users/delete/", {
					data: {
						emails: this.delete_user_list
					}
				})
				.then(this.deleteUserResponse)
				.catch(error => {
					console.log("error");
				});
		},
		shownDeleteOptions() {
			this.show_delete_options = true;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./AppUpdateStore.scss";
</style>
